module.exports = __webpack_public_path__ + "static/media/cat-opacity-15.4b288467.png";